import NewLayout from "@components/new-ui/Layout";
import { CompanyTrustBanner } from "@components/Webinar/CompanyTrustBanner";
import IndividualWebinar, { IndividualWebinarProps } from "@components/Webinar/IndividualWebinar";

const HeroSectionData: IndividualWebinarProps = {
    title: "WhatsApp Marketing 2025: Campaigns That Convert",
    listHeading:
        "WhatsApp isn't just for support anymore — it's fast becoming a high-conversion marketing channel. But most brands are stuck using it for generic broadcasts. What you’ll learn in this session:",
    listText: [
        { label: "Why WhatsApp should be your top-performing channel in 2025" },
        { label: "How to grow and segment your WhatsApp list" },
        { label: "The structure of a high-converting message (with examples)" },
        { label: "Drip campaigns, automated flows, and conversion strategies" },
    ],
    mediaUrl: "https://assets.gallabox.com/gb-home/webinar/webinar-5.png",
    youtubeURL: "https://youtu.be/_TAt9y7m6xs",
    speakerList: [
        {
            image: "/ranganayaki.png",
            name: "Ranganayaki R",
            role: "Whatsapp Evangelist",
        },
        {
            image: "/shoaib.png",
            name: "Shoaib Ahmed",
            role: "Growth Specialist",
        },
    ],
    inThisWebinar: "What you'll learn in this session:",
    webinarSlug: "whatsapp-playbook",
};

const Webinar: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp marketing playbook for 2025 - Gallabox webinars"
            description="45 minutes that will show you proven strategies to run WhatsApp campaigns that drive real conversions in 2025"
            canonical="https://gallabox.com/webinars/whatsapp-playbook"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/webinar/webinar-5.png" }}
        >
            <IndividualWebinar {...HeroSectionData} />
            <CompanyTrustBanner />
        </NewLayout>
    );
};

export default Webinar;
